import { FeatureFlagList } from '../api/common/types'
import { useStore } from '../stores/useStore'

export function useFeatureEnabled(feature: FeatureFlagList) {
  const features = useStore(({ session }) => session?.enabled_features ?? [])

  return features.includes(feature)
}
